import { render } from "./InterfaceRouterContainer.vue?vue&type=template&id=028b170a&scoped=true"
import script from "./InterfaceRouterContainer.vue?vue&type=script&lang=js"
export * from "./InterfaceRouterContainer.vue?vue&type=script&lang=js"

import "./InterfaceRouterContainer.vue?vue&type=style&index=0&id=028b170a&scoped=true&lang=scss"

import exportComponent from "/tmp/6f278242-b890-433a-91e8-ee1cfc12c380/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028b170a"]])

export default __exports__